import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom/client';
import SecurSpaceApp from "./SecurSpaceApp";
import {unregister} from './registerServiceWorker';
import '../src/css/theme/hs-elements.css';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import {asyncWithLDProvider} from "launchdarkly-react-client-sdk";

(async () => {
  const launchDarklyClientId = import.meta.env.VITE_LAUNCH_DARKLY_ACCESS_KEY;

  if (!launchDarklyClientId) {
    console.error(
      '[LaunchDarkly] VITE_LAUNCH_DARKLY_ACCESS_KEY is not set, so flags will ' +
      'fall back to their defaults. Add it to .env.local — see ' +
      'ARCHITECTURE.md § Environment Variables.'
    );
  }

  const AsyncLDProvider = await asyncWithLDProvider({
    clientSideID: launchDarklyClientId ?? '',
    context: {
      kind: 'user',
      anonymous: true,
      key: 'anonymous-bootstrap',
    },
  });
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <AsyncLDProvider>
      <StyledEngineProvider injectFirst>
        <SecurSpaceApp />
      </StyledEngineProvider>
    </AsyncLDProvider>
  )

  unregister();
})();
